
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import { DynamicField, DynamicFieldOutput } from "@/types/dynamic-data";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import DynamicDataFields from "@/components/Reusable/ControlsTree/DynamicData/DynamicDataFields.vue";
import Icon from "@/components/UI/Icon.vue";
import IconButton from "@/components/UI/IconButton.vue";
import Dialog from "@/components/UI/Dialog.vue";
import { getShortcodeFromDynamicField } from "@/lib/dynamic-data/utils";
import VideoInput from "@/components/Reusable/CustomInputs/VideoInput.vue";
import DynamicDataPromotionVideo from "@/components/Subscription/DynamicDataPromotionVideo.vue";
import { configStore } from "@/store/store-accessor";
import { ControlsTreeContext } from "@/types/controls";
import { isDynamicFieldProOnlyAndUserIsOnFreeTier } from "@/lib/subscriptions/free-mode";
import { DynamicFieldReturnType } from "@/types/dynamic-property-path";

@Component({
  components: {
    DynamicDataPromotionVideo,
    VideoInput,
    Dialog,
    IconButton,
    Icon,
    DynamicDataFields,
    DropdownInput,
    TextInput
  }
})
export default class DynamicDataDialog extends Vue {
  @Prop()
  value!: boolean;

  @Prop()
  dynamicField: DynamicFieldOutput | undefined;

  @Prop()
  accepts!: DynamicFieldReturnType | false;

  @Prop()
  path?: string;

  chosenField?: DynamicField;

  get selectedField() {
    return this.dynamicField?.field?.slug;
  }

  @Inject({ from: "context", default: {} })
  readonly context!: ControlsTreeContext;

  get dynamicProperty() {
    return this.path ? this.context.dynamicProperty(this.path) : false;
  }

  get dynamicProOnly() {
    return (
      this.dynamicProperty &&
      this.dynamicProperty.proOnly &&
      configStore.subscriptionMode === "free"
    );
  }

  setField(field: DynamicField) {
    if (isDynamicFieldProOnlyAndUserIsOnFreeTier(field)) {
      alert("Please upgrade to Breakdance Pro to use this field.");
      return;
    }

    this.chosenField = field;
    this.saveAndClose();
  }

  reset() {
    this.chosenField = undefined;
  }

  goBack() {
    this.reset();
  }

  close() {
    this.$emit("close");
  }

  save() {
    if (!this.chosenField) {
      this.close();

      return;
    }

    const chosenFieldAttributes = this.chosenField.defaultAttributes ?? {};

    const shortcode = getShortcodeFromDynamicField(
      chosenFieldAttributes,
      this.chosenField
    );

    this.$emit("selected", {
      field: this.chosenField,
      shortcode,
      attributes: chosenFieldAttributes
    });
  }

  saveAndClose() {
    this.save();
    this.close();
    this.reset();
  }
}
